import { ColumnsType } from '@setvi/shared/types';
import { Customer } from 'Services/Mongo/Types';
import {
  ProductColumn,
  ProductDetailsColumnsIds,
  ProductInventory,
  ProductWarehouse
} from '@setvi/shared/interfaces';
import { getWarehouseCellContent } from './columns-content';

export const getWarehouseLocation = (warehouse: ProductWarehouse) => {
  if (!warehouse || (!warehouse.city && !warehouse.state))
    return warehouse?.name || '-';

  return `${warehouse.city && warehouse.city}${
    warehouse.city && warehouse.state ? ',' : ''
  } ${warehouse.state && warehouse.state}`;
};

interface useWarehouseColumnsProps {
  selectedCustomer?: Customer;
  configColumns: ProductColumn[];
  mobile?: boolean;
}

export const useWarehouseColumns = ({
  selectedCustomer,
  configColumns = [],
  mobile = false
}: useWarehouseColumnsProps) => {
  const warehouseColumns: ColumnsType = configColumns.map(column => ({
    ...column,
    cellContent: (row: ProductInventory) =>
      getWarehouseCellContent({
        id: column.id as ProductDetailsColumnsIds,
        row,
        mobile,
        selectedCustomer,
        getWarehouseLocation
      })
  }));

  return {
    warehouseColumns
  };
};
